<img class="w-100" src="../../assets/img/222.png" alt="">
<div class="container">
   
  
    <div class="row">

        <div class="col-md-3">



            <div class="shop-sidebar mt-3">


             

                <div class="shop-sidebar-category">
                    <h4 class="sidebar-title">Top Categories</h4>
                    <div  class="sidebar-category">
                        <ngx-treeview *ngIf="isLoaded" [config]="config" [items]="newItems" (selectedChange)="onSelectedChange($event)"
                            (filterChange)="onFilterChange($event)">
                        </ngx-treeview>
                    </div>
                </div>


                <div class="shop-sidebar-category">
                    <h4 class="sidebar-title">Sizes</h4>
              
                    <div class="sidebar-category">

               <div *ngFor="let size of sizeArray; let x=index" class="form-inline row-item mb-2">
               <div class="form-check">
                <input id="size_{{x}}" (change)="isFilterChecked('Size', size.Size)" type="checkbox" class="form-check-input">
           <label for="size_{{x}}" class="form-check-label"> {{size.Size}} </label></div>
            </div>

                      
                    </div>
                </div>


               
            </div>

          
        </div>

        <div class="col-md-9" (ngClass)="showCategoryFilter?'col-md-9':'col-md-12'">


          
         
            <div class="shop-section">
                    <div class="shop-section-top-inner">
                        <div class="shoping-list">
                            <ul class="nav nav-mb-3 main-tab" id="tab" role="tablist">
                                <li class="nav-item" role="presentation">
                                    <button [ngClass]="!isListView ? 'active':''" (click)="isListView=false" class="nav-link" id="grid-tab" data-bs-toggle="pill" data-bs-target="#grid" type="button"
                                        role="tab" aria-controls="grid" aria-selected="false"><i class="fa fa-th "></i></button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button [ngClass]="isListView ? 'active':''" (click)="isListView=true" class="nav-link" id="list-tab" data-bs-toggle="pill" data-bs-target="#list" type="button"
                                        role="tab" aria-controls="list" aria-selected="true"><i class="fa fa-list "></i></button>
                                </li>
                            </ul>
                        </div>
                        <div class="shoping-product">
                            <span>Showing Products 1 - 9 Of 13 Result</span>
                        </div>
                        <div class="short-by">
                            <div class="input-group">
                                <input placeholder="Search" type="search" class="shop-filter-search">
                                <div class="input-group-append">
                                 <button type="button" class="btn-theme pl-3 pr-3">
                                    <i class="fa fa-search"></i>
                                 </button>
                                </div>
                            </div>
                        
                        </div>
                    </div>
            </div>

            <div *ngIf="(selectedCategories.length > 0 || filterText != '') && items.length == 0" class="no-records">
                <div class="no-records-container">
                    <div class="no-records-icon">
                        <i class="fa fa-search"></i> <!-- Example icon, you can use any other icon -->
                    </div>
                    <div class="no-records-message">
                        We couldn't find any products matching with your search criteria.
                    </div>
                    <div class="no-records-subtext">
                        Please try adjusting your filters or search for something else.
                    </div>
                  
                </div>
            </div>

        

            <div class="center">
                <span class="fa fa-loading color-primary" *ngIf="isLoaded==false"></span>
            </div>
            <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                (scrolled)="onScroll()">


                <div class="row" *ngIf="!isListView">

<div *ngFor="let item of items" class="col-sm-6 col-xl-4">
    <!--== Start Product Item ==-->
    <div class="product-item">
        <div class="inner-content">
            <div class="product-thumb">
                <a (click)="navigateToProductDetail(item.Id)">
                    <img src="{{item.ImagePath}}" width="270" height="274" alt="Image-HasTech">
                </a>

                <div class="product-flag">
                    <ul>
                        <li class="discount">{{item.Size}}</li>
                    </ul>
                </div>
                <div class="product-action">
               
                    
                    <a class="btn-product-cart" (click)="addToCart(item)"><i class="fa fa-shopping-cart"></i></a>
                    <button type="button" class="btn-product-quick-view-open">
                        <i class="fa fa-arrows"></i>
                    </button>
                  
                </div>
             
            </div>
            <div class="product-info">
            
                <h4 ><a>{{item.ProductName}}</a></h4>
                <div class="prices">
                 
                    <span class="price">₹ {{item.Cost
                    *(item.selectedQuantity==0?1:item.selectedQuantity)}}</span>
                </div>
            </div>
        </div>
    </div>
    <!--== End prPduct Item ==-->
</div>

                    <div class="col-12 col-sm-4 col-md-4 d-none" *ngFor="let item of items">
                        <figure class="product-list mb-3 border p-3">
                            <div class="row">
                                <div class="col-3 col-md-3">
                                    <a (click)="navigateToProductDetail(item.Id)" class="img-wrap">
                                        <img src="{{item.ImagePath}}">
                                    </a>
                                    <div class="marginText">
                                        <a class="btn-link badge badge-warning text-danger ">
                                            {{item.Discount}}%</a> &nbsp;

                                    </div>
                                </div>
                                <div class="info-wrap col-8 col-md-8">
                                    <p class="title">{{item.ProductName}} </p>
                                    <small class="text-muted">{{item.CategoryName}}</small>
                                    <div class="price-wrap mb-2">
                                        <span class="price"><strong class="">Rs. {{item.Cost
                                                *(item.selectedQuantity==0?1:item.selectedQuantity)}}</strong></span>
                                    </div>
                                    <!-- <div class="btn-group">
                                                        <a href="#" class="btn btn-sm btn-light"> <i class="fa fa-shopping-cart"></i> Add </a>
                        
                                                        
                                                    </div> -->


                                    <div class="input-group input-group-sm input-spinner" *ngIf="item.isAddedToCart">
                                        <div class="input-group-prepend">
                                            <button class="btn btn-sm btn-light" (click)="updateCart('plus',item)"
                                                type="button" id="button-plus"> <i class="fa fa-plus"></i>
                                            </button>
                                        </div>
                                        <input type="text" readonly class="form-control"
                                            value="{{item.selectedQuantity}}">
                                        <div class="input-group-append">
                                            <button class="btn btn-sm btn-light" (click)="updateCart('minus',item)"
                                                type="button" id="button-minus"> <i class="fa fa-minus"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <a (click)="addToCart(item)" *ngIf="!item.isAddedToCart"
                                        class="btn btn-sm btn-light">
                                        <i class="fa fa-shopping-cart"></i> Add
                                    </a> &nbsp;
                                    <a routerLink="#" class="btn btn-sm btn-light"> <i class="fa fa-heart"></i> </a>

                                </div>
                            </div>
                        </figure>
                    </div>
                </div>

                <div *ngIf="isListView" class="row">
                    <div class="col-md-12">
                        <div *ngFor="let item of items" style="padding: 0; margin-bottom: 20px;" class="product-item product-list-item">
                            <div class="inner-content">
                                <div class="product-thumb">
                                    <a (click)="navigateToProductDetail(item.Id)">
                                        <img src="{{item.ImagePath}}" width="322" height="360" alt="Image-HasTech">
                                    </a>
                                    <div class="product-flag">
                                        <ul>
                                            <li class="discount">{{item.Size}}</li>
                                        </ul>
                                    </div>
                        
                        
                                </div>
                                <div  class="product-info p-2 pl-4">
                                   
                                    <h4 class="title"><a>{{item.ProductName}}</a></h4>
                                    <div class="prices">
                        
                                        <span class="price">₹ {{item.Cost}}</span>
                                    </div>
                                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatem quo, rerum rem soluta quisquam,
                                        repellat is deleniti omnis culpa ea quis provident dolore esse, offici modi dolorem nam cum eligendi
                                        enim!</p>
                                    <a class="btn-theme btn-sm" (click)="addToCart(item)">Add To Cart</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>